import { useEffect, useRef } from 'react';

/**
 * Une surcouche prend le focus à l'ouverture et le rend à la fermeture — audit
 * UI/UX du 2026-09-23. Sans ça, VoiceOver continue de lire l'écran de derrière.
 *
 * Volontairement SANS gestion de l'historique : un `pushState` par surcouche casse
 * les surcouches imbriquées (le sélecteur d'établissement vit dans le panneau), se
 * referme tout seul en StrictMode et laisse des « précédent » morts. Le retour par
 * balayage passe par la pile unique de `useFermetureParRetour` (D6), que chaque
 * surcouche appelle à côté de celui-ci.
 */
export function useFocusSurcouche(ouverte: boolean) {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!ouverte) return;
        const precedent = document.activeElement as HTMLElement | null;
        ref.current?.focus();
        return () => {
            precedent?.focus?.();
        };
    }, [ouverte]);

    return ref;
}
